import { render, staticRenderFns } from "./page-wrapper.component.vue?vue&type=template&id=03a30bf8&"
import script from "./page-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./page-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports